import React, { ReactNode } from 'react';
import { Breadcrumb } from 'react-bootstrap';

import { _PageTitleId } from './_PageTitleId/_PageTitleId';

import './PageTitle.scss';

interface BreadcrumbItemDefinition {
  href?: string;
  /**
   * The linked text or component(s).
   */
  content?: ReactNode;
}

export type BreadcrumbItem = BreadcrumbItemDefinition | null;

export interface PageTitleProps {
  children: ReactNode;
  className?: string;
  breadcrumbs: BreadcrumbItem[];
}

export const PageTitle = ( props: PageTitleProps ) => {
  const { breadcrumbs, children, className } = props;

  return (
    <header data-testid="ops-page-title" className={ `ops-page-title${className ? ` ${className}` : ''}` }>
      <h2 className="ops-page-title__heading">{ children }</h2>

      { breadcrumbs.length > 0 && (
        <Breadcrumb data-testid="ops-page-title__breadcrumbs" className="ops-page-title__breadcrumbs">
          { breadcrumbs.map( ( crumb, index ) => {
            if ( !crumb ) {
              return crumb;
            }

            const hasHref = typeof crumb.href === 'string';

            return (
              <Breadcrumb.Item
                key={ index }
                data-testid="ops-page-title__breadcrumb-item"
                className="ops-page-title__breadcrumb-item"
                href={ crumb.href }
                active={ !hasHref }
              >
                { crumb.content }
              </Breadcrumb.Item>
            );
          } ) }
        </Breadcrumb>
      ) }
    </header>
  );
};

PageTitle.displayName = 'PageTitle';
PageTitle.Id = _PageTitleId;
